import { render, staticRenderFns } from "./SecondaryTaskList.vue?vue&type=template&id=f150c2da&scoped=true"
import script from "./SecondaryTaskList.vue?vue&type=script&lang=js"
export * from "./SecondaryTaskList.vue?vue&type=script&lang=js"
import style0 from "./SecondaryTaskList.vue?vue&type=style&index=0&id=f150c2da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f150c2da",
  null
  
)

export default component.exports